import { motion } from 'framer-motion'

export default function Privacy() {
  return (
    <div className="min-h-screen bg-pp-ivory">
      {/* Hero */}
      <section className="bg-pp-linen py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="font-display text-display-lg text-pp-ink mb-6">
              Privacy Policy
            </h1>
            <p className="text-pp-stone text-lg leading-relaxed">
              Last updated: January 2024
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl mx-auto prose prose-stone"
          >
            <div className="bg-white rounded-2xl p-8 lg:p-12 border border-pp-sand/50 space-y-8 text-pp-stone">
              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Introduction
                </h2>
                <p className="leading-relaxed">
                  Petite Palate ("we", "our", or "us") is committed to protecting
                  your privacy. This Privacy Policy explains how we collect, use,
                  disclose, and safeguard your information when you visit our
                  website petitepalate.com.au and make purchases from us.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Information We Collect
                </h2>
                <p className="leading-relaxed mb-4">
                  We collect information that you provide directly to us, including:
                </p>
                <ul className="list-disc list-inside space-y-2 text-sm">
                  <li>
                    Name, email address, and contact information when you create an
                    account or place an order
                  </li>
                  <li>Shipping and billing address for order fulfilment</li>
                  <li>Payment information (processed securely through Stripe)</li>
                  <li>
                    Communications you send to us (customer support inquiries, etc.)
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  How We Use Your Information
                </h2>
                <p className="leading-relaxed mb-4">
                  We use the information we collect to:
                </p>
                <ul className="list-disc list-inside space-y-2 text-sm">
                  <li>Process and fulfil your orders</li>
                  <li>Send order confirmations and shipping updates</li>
                  <li>Respond to your comments and questions</li>
                  <li>
                    Send marketing communications (with your consent) such as
                    newsletters and promotions
                  </li>
                  <li>Improve our website and products</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Information Sharing
                </h2>
                <p className="leading-relaxed">
                  We do not sell, trade, or rent your personal information to third
                  parties. We may share your information with service providers who
                  assist us in operating our website and conducting our business
                  (e.g., payment processing, shipping), but they are bound by
                  confidentiality agreements.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Data Security
                </h2>
                <p className="leading-relaxed">
                  We implement appropriate security measures to protect your
                  personal information. All payment transactions are processed
                  through Stripe, which uses industry-standard encryption. However,
                  no method of transmission over the Internet is 100% secure.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Your Rights
                </h2>
                <p className="leading-relaxed mb-4">You have the right to:</p>
                <ul className="list-disc list-inside space-y-2 text-sm">
                  <li>Access the personal information we hold about you</li>
                  <li>Request correction of inaccurate information</li>
                  <li>Request deletion of your personal information</li>
                  <li>Opt-out of marketing communications at any time</li>
                </ul>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">Cookies</h2>
                <p className="leading-relaxed">
                  Our website uses cookies to enhance your browsing experience.
                  Cookies are small files stored on your device that help us
                  remember your preferences and understand how you use our site. You
                  can disable cookies in your browser settings, though this may
                  affect some website functionality.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Contact Us
                </h2>
                <p className="leading-relaxed">
                  If you have questions about this Privacy Policy or wish to
                  exercise your rights, please contact us at:
                </p>
                <p className="mt-4 text-sm">
                  Email: hello@petitepalate.com.au
                  <br />
                  Petite Palate
                  <br />
                  Melbourne, Australia
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  )
}
